import { Component, OnInit } from '@angular/core';
import {IResponse, locales} from "../../interfaces/iresponse";
import {UtilService} from "../../services/utilService/util.service";
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-manage-rides',
  templateUrl: './manage-rides.component.html',
  styleUrls: ['./manage-rides.component.css']
})
export class ManageRidesComponent implements OnInit {
  breadCrumb: any;
  timeKeeper: any;
  public allRides: any[] = [];
  public viewRiders: any[] = [];
  loadingData = false;
  isRiderInfo = false;

  constructor(
    private utilService: UtilService,
    private superAdminService: SuperAdminService) { }


  ngOnInit() {
    this.breadCrumb  = {
      name: 'Registered Rides',
      parent: 'Home',
      subLink: null
    };
    this.getAllRides();
  }

  activeOperator(){
    const operator = this.utilService.getAuthUser();
    console.log(operator)
  }

  getAllRides() {
    this.loadingData = true;
    this.superAdminService.getAllRides()
      .subscribe((res: IResponse) => {
        this.allRides = res.data;
        this.utilService.startDatatable('all-rides');
        this.loadingData = false;
      }, error => {
        this.utilService.startDatatable('all-rides');
        this.loadingData = false;
      });
  }
  viewAllRiders(ride) {
    this.viewRiders = ride.riders;
    this.isRiderInfo = true;
    clearTimeout(this.timeKeeper);
    this.utilService.openModal('riderDetails');
  }
  closeInformation() {
    this.timeKeeper =  setTimeout(() => {
      this.viewRiders = [];
      this.isRiderInfo = false;
    }, 3000);
  }


}
